import { isEmpty } from 'lodash'

const withPrefix = (value) => {
  if (isEmpty(value)) return ''
  return value?.startsWith('+') ? value : '+' + value
}

const phone = {
  withPrefix,
}

export default phone
